import { Box, Container } from "@mui/material";
import { styled } from "@mui/material/styles";

const LandingPageContainer = styled(Box)(() => ({
  backgroundColor: "var(--background-page)",
  minHeight: "100vh",
}));

const MainContentContainer = styled(Container)(({ theme }) => ({
  width: "calc(100% - 24px)",
  maxWidth: "1200px",
  marginTop: theme.spacing(8),
  display: "flex",
  flexDirection: "column",
  gap: "150px",
  paddingBottom: theme.spacing(18.75),
  [theme.breakpoints.down("md")]: {
    gap: "80px",
    paddingBottom: theme.spacing(10),
  },
}));

import {
  HeroSection,
  MissionStatement,
  FeaturesGrid,
  HowItWorksProcess,
  WhatIsImportantToKnow,
} from "../components";

export default function LandingPage() {
  return (
    <LandingPageContainer>
      <HeroSection />
      <MainContentContainer disableGutters>
        <MissionStatement />
        <FeaturesGrid />
        <HowItWorksProcess />
        <WhatIsImportantToKnow />
      </MainContentContainer>
    </LandingPageContainer>
  );
}
